export const SET_COMPONENTS = 'SET.COMPONENTS';
export const SET_COMPONENTS_LOADING = 'SET.COMPONENTS.LOADING';
export const UNSET_COMPONENTS_LOADING = 'UNSET.COMPONENTS.LOADING';
